var Vue = require('vue');
var ManualAssignment = require('./components/ManualAssignment.vue').default;

module.exports = function() {
  new Vue({
    el: '#manual-assignment',
    components: {
      'manual-assignment': ManualAssignment
    }
  });
};
